function miauInstallPageDialogStyles() {
  if(document.getElementById("miau-page-dialog-style"))return;
    const style = document.createElement('style');
    style.id="miau-page-dialog-style";
    style.textContent = '.miau-size-dialog{box-sizing:border-box;padding:0;border:0;width:min(1100px,calc(100% - 48px));height:calc(100dvh - 48px);max-width:none;max-height:none;overflow:hidden;background:white;color:#111}.miau-size-dialog::backdrop{background:#0009}.miau-size-shell{height:100%;display:flex;flex-direction:column}.miau-size-toolbar{display:flex;justify-content:space-between;align-items:center;gap:12px;padding:12px 20px;border-bottom:1px solid #ddd;font:14px Arial,sans-serif}.miau-size-toolbar a{color:inherit}.miau-size-toolbar button{background:white;color:#111;border:1px solid #aaa;min-height:44px;padding:10px 14px;cursor:pointer}.miau-size-frame{width:100%;flex:1;min-height:0;border:0}.miau-size-toolbar :focus-visible{outline:2px solid #111;outline-offset:3px}@media(max-width:650px){.miau-size-dialog{width:100%;height:100dvh;margin:0}.miau-size-toolbar{padding:10px 16px;padding-top:max(10px,env(safe-area-inset-top))}.miau-size-shell{padding-bottom:env(safe-area-inset-bottom)}}';
    document.head.append(style);
}

function miauGuideBegin(link) {
  if(!document.querySelector('.miau-dialog[open],.miau-size-dialog[open]')) {
    window.miauGuideReturn={link,overflow:document.documentElement.style.overflow};
  }
}
function miauGuideClosed() {
  if(document.querySelector('.miau-dialog[open],.miau-size-dialog[open]'))return;
  document.documentElement.style.overflow=window.miauGuideReturn?.overflow||'';
  window.miauGuideReturn?.link?.focus();
}

function miauGuideTrigger(event, kind) {
  const link=event.composedPath().find(node=>node instanceof HTMLAnchorElement);
  if(!link || link.hasAttribute('data-miau-full-page')) return null;
  const url=new URL(link.dataset.miauUrl||link.href,location.href);
  if(url.origin!==location.origin)return null;
  const handle=kind==='fit'?'find-your-miau':'size-guide';
  return url.pathname.replace(/\/$/,'').endsWith('/pages/'+handle)?link:null;
}
(() => {
  if (window.miauFinderInstalled) return;
  window.miauFinderInstalled = true;
  const words = {
    en: { close: 'Close', title: 'Find Your MÏAU', page: 'Open the full guide' },
    es: { close: 'Cerrar', title: 'Find Your MÏAU', page: 'Abrir la guía completa' },
    pt: { close: 'Fechar', title: 'Find Your MÏAU', page: 'Abrir o guia completo' }
  };
  let dialog, frame, opener, previousOverflow, activeUrl;
  const locale = () => document.documentElement.lang.split('-')[0] in words ? document.documentElement.lang.split('-')[0] : 'en';
  function create() {
    const style = document.createElement('style');
    style.textContent = `.miau-dialog{box-sizing:border-box;padding:0;border:0;border-radius:6px;width:min(1000px,calc(100% - 48px));height:min(850px,calc(100dvh - 48px));max-width:none;max-height:none;background:#f6f3eb;color:#20231e;overflow:hidden}.miau-dialog::backdrop{background:rgb(20 23 18 / .6)}.miau-shell{height:100%;display:flex;flex-direction:column}.miau-toolbar{display:flex;justify-content:space-between;align-items:center;gap:12px;padding:12px 20px;border-bottom:1px solid #ddd9cf;font:16px Arial,sans-serif}.miau-toolbar a{color:inherit;font-size:13px}.miau-close{font:inherit;background:transparent;color:inherit;border:1px solid #aaa;padding:10px 14px;min-height:44px;cursor:pointer}.miau-close:focus-visible,.miau-toolbar a:focus-visible{outline:2px solid #20231e;outline-offset:3px}.miau-frame{display:block;width:100%;flex:1;min-height:0;border:0;background:#f6f3eb;overflow:auto}@media(max-width:650px){.miau-dialog{width:100%;height:100dvh;margin:0;border-radius:0}.miau-toolbar{padding:10px 16px;padding-top:max(10px,env(safe-area-inset-top))}.miau-shell{padding-bottom:env(safe-area-inset-bottom)}}`;
    document.head.append(style);
    dialog = document.createElement('dialog');
    dialog.className = 'miau-dialog';
    dialog.setAttribute('aria-label', 'Find Your MÏAU');
    dialog.innerHTML = '<div class="miau-shell"><div class="miau-toolbar"><a class="miau-full" data-miau-full-page></a><button class="miau-close" type="button" autofocus></button></div><div class="miau-frame"></div></div>';
    frame = dialog.querySelector('.miau-frame');
    document.body.append(dialog);
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {
      miauGuideClosed();
    });
    dialog.addEventListener('miau:close', () => dialog.close());
  }

  let scriptReady;
  async function loadGuide(url) {
    frame.textContent = {en:'Loading…',es:'Cargando…',pt:'Carregando…'}[locale()];
    try {
      const response = await fetch(url, {credentials:'same-origin'});
      if (!response.ok) throw new Error('Guide unavailable');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const config = JSON.parse(page.querySelector('#miau-config').textContent);
      const shadow = frame.shadowRoot || frame.attachShadow({mode:'open'});
      frame.textContent = '';
      const styles = page.querySelector('#miau-guide-style').textContent.replaceAll(':root', ':host').replaceAll('body{', ':host{').replaceAll('html[data-embedded]', ':host');
      shadow.innerHTML = '<style>'+styles+'</style>'+page.querySelector('main').outerHTML;
      if (!scriptReady) scriptReady = new Promise((resolve,reject) => {
        const script = document.createElement('script'); script.src=config.script; script.onload=resolve; script.onerror=reject; document.head.append(script);
      });
      await scriptReady;
      window.miauFinderInit(shadow, config, locale());
    } catch (error) { activeUrl = undefined; scriptReady = undefined; frame.textContent = {en:'Please use the full guide link above.',es:'Abre la guía completa con el enlace de arriba.',pt:'Abra o guia completo pelo link acima.'}[locale()]; }
  }
  document.addEventListener('click', e => {
    const trigger = miauGuideTrigger(e, 'fit');
    if (!trigger || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const raw = trigger.dataset.miauUrl || trigger.getAttribute('href');
    if (!raw || typeof HTMLDialogElement === 'undefined') return;
    const url = new URL(raw, location.href);
    if (!['https:', 'http:', 'file:'].includes(url.protocol)) return;
    e.preventDefault();
    miauGuideBegin(trigger);
    document.querySelectorAll('.miau-size-dialog[open]').forEach(d=>d.close());
    if (!dialog) create();
    const c = words[locale()];
    dialog.querySelector('button').textContent = c.close + ' ×';
    const full = dialog.querySelector('a');
    full.textContent = c.page;
    full.href = url.href;
    full.hreflang = locale();
    url.searchParams.set('embed', '1');
    url.searchParams.set('lang', locale());
    if (activeUrl !== url.href) { activeUrl = url.href; loadGuide(url.href); }
    opener = trigger;
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
  });
})();

(() => {
  if (window.miauSizeInstalled) return;
  window.miauSizeInstalled = true;
  let dialog, frame, opener, overflow;
  const language = document.documentElement.lang.split('-')[0];
  const words = {en:['Size guide','Close','Open the full guide'],es:['Guía de tallas','Cerrar','Abrir la guía completa'],pt:['Guia de tamanhos','Fechar','Abrir o guia completo']}[language] || ['Size guide','Close','Open the full guide'];
  function create(url) {
    miauInstallPageDialogStyles();
    dialog = document.createElement('dialog');
    dialog.className='miau-size-dialog'; dialog.setAttribute('aria-label',words[0]);
    dialog.innerHTML='<div class="miau-size-shell"><div class="miau-size-toolbar"><a target="_blank" rel="noopener" data-miau-full-page></a><button type="button" autofocus></button></div><div class="miau-size-frame"></div></div>';
    const full=dialog.querySelector('a'); full.textContent=words[2]; full.href=url;
    const close=dialog.querySelector('button'); close.textContent=words[1]+' ×'; close.onclick=()=>dialog.close();
    frame=dialog.querySelector('.miau-size-frame'); frame.style.overflow='auto';
    frame.textContent={es:'Cargando…',pt:'Carregando…'}[language]||'Loading…';
    fetch(url,{credentials:'same-origin'}).then(response=>{if(!response.ok)throw Error('Guide unavailable');return response.text()}).then(html=>{
      const page=new DOMParser().parseFromString(html,'text/html');
      const main=page.querySelector('main'); if(!main)throw Error('Guide unavailable');
      main.querySelectorAll('script').forEach(script=>script.remove());
      main.querySelectorAll('a').forEach(a=>a.target='_top');
      const root=frame.attachShadow({mode:'open'});
      const styles=Array.from(page.querySelectorAll('style,link[rel="stylesheet"]')).map(style=>{const copy=style.cloneNode(true);if(copy.tagName==='STYLE')copy.textContent=copy.textContent.replaceAll(':root',':host');else copy.href=new URL(style.getAttribute('href'),url).href;return copy});
      const base=document.createElement('style');base.textContent=':host{display:block;font-family:var(--font-body--family,Arial,sans-serif);color:#111;background:white}main{margin:0!important}';
      root.append(...styles,base,main);
    }).catch(()=>{frame.textContent={es:'Abre la guía completa con el enlace de arriba.',pt:'Abra o guia completo pelo link acima.'}[language]||'Please use the full guide link above.'});
    dialog.addEventListener('close',miauGuideClosed);
    dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});
    document.body.append(dialog);
  }
  document.addEventListener('click',e=>{
    const link=miauGuideTrigger(e, 'size');
    if(!link||e.defaultPrevented||e.button>0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||typeof HTMLDialogElement==='undefined')return;
    e.preventDefault();
    miauGuideBegin(link);
    document.querySelectorAll('.miau-dialog[open],.miau-policy-dialog[open]').forEach(d=>d.close());
    if(!dialog)create(link.href);
    opener=link; overflow=document.documentElement.style.overflow;
    document.documentElement.style.overflow='hidden'; dialog.showModal();
  });
})();

// Product policy links reuse the page dialog, with content fetched only on demand.
(() => {
  if (window.miauPolicyInstalled) return;
  window.miauPolicyInstalled = true;
  const dialogs = new Map();
  const language = document.documentElement.lang.split('-')[0];
  const closeText = {en:'Close',es:'Cerrar',pt:'Fechar',fr:'Fermer'}[language] || 'Close';
  const loadingText = {en:'Loading…',es:'Cargando…',pt:'Carregando…',fr:'Chargement…'}[language] || 'Loading…';
  function create(url, title) {
    miauInstallPageDialogStyles();
    const dialog = document.createElement('dialog');
    dialog.className = 'miau-size-dialog miau-policy-dialog';
    dialog.setAttribute('aria-label', title);
    const shell = document.createElement('div'); shell.className = 'miau-size-shell';
    const toolbar = document.createElement('div'); toolbar.className = 'miau-size-toolbar';
    const full = document.createElement('a'); full.href = url.href; full.textContent = title;
    full.target = '_blank'; full.rel = 'noopener'; full.setAttribute('data-miau-full-page','');
    const close = document.createElement('button'); close.type = 'button'; close.autofocus = true;
    close.textContent = closeText + ' ×'; close.addEventListener('click',()=>dialog.close());
    const frame = document.createElement('div'); frame.className = 'miau-size-frame'; frame.style.overflow = 'auto';
    const shadow = frame.attachShadow({mode:'open'});
    toolbar.append(full,close); shell.append(toolbar,frame); dialog.append(shell);
    dialog.addEventListener('close',miauGuideClosed);
    dialog.addEventListener('click',event=>{if(event.target === dialog)dialog.close();});
    document.body.append(dialog);
    return {dialog,shadow,loaded:false};
  }
  async function load(entry, url) {
    entry.loaded = true;
    const status = document.createElement('p'); status.setAttribute('role','status'); status.textContent = loadingText;
    entry.shadow.replaceChildren(status);
    try {
      const response = await fetch(url.href,{credentials:'same-origin'});
      if(!response.ok)throw new Error('Policy unavailable');
      const page = new DOMParser().parseFromString(await response.text(),'text/html');
      const content = page.querySelector('.shopify-policy__container');
      if(!content)throw new Error('Policy unavailable');
      content.querySelectorAll('script').forEach(node=>node.remove());
      content.querySelectorAll('a[href]').forEach(link=>{link.href=new URL(link.getAttribute('href'),url.href).href;});
      const styles = Array.from(page.querySelectorAll('style,link[rel="stylesheet"]')).map(node=>{
        const copy=node.cloneNode(true);
        if(copy.tagName === 'STYLE')copy.textContent=copy.textContent.replaceAll(':root',':host');
        else copy.href=new URL(node.getAttribute('href'),url.href).href;
        return copy;
      });
      const base = document.createElement('style');
      base.textContent=':host{display:block;font-family:var(--font-body--family,Arial,sans-serif);color:var(--color-foreground,#111);background:var(--color-background,#fff)}.shopify-policy__container{box-sizing:border-box;width:100%;max-width:850px;margin:0 auto;padding:24px;overflow-wrap:anywhere}.shopify-policy__title h1{font-size:clamp(24px,5vw,40px);line-height:1.2}.shopify-policy__body{font-size:16px;line-height:1.6}img,table{max-width:100%}@media(max-width:650px){.shopify-policy__container{padding:20px 16px}}';
      entry.shadow.replaceChildren(...styles,base,content);
    } catch {
      entry.loaded = false;
      const fallback = document.createElement('a'); fallback.href = url.href; fallback.textContent = entry.dialog.getAttribute('aria-label');
      fallback.setAttribute('data-miau-full-page',''); entry.shadow.replaceChildren(fallback);
    }
  }
  document.addEventListener('click',event=>{
    if(event.defaultPrevented || event.button>0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || typeof HTMLDialogElement==='undefined')return;
    const link=event.composedPath().find(node=>node instanceof HTMLAnchorElement);
    if(!link || link.hasAttribute('data-miau-full-page') || !link.closest('#MainContent') || !location.pathname.includes('/products/'))return;
    const url=new URL(link.href,location.href);
    if(url.origin!==location.origin || !/\/policies\/(shipping-policy|refund-policy)\/?$/.test(url.pathname))return;
    event.preventDefault(); miauGuideBegin(link);
    document.querySelectorAll('.miau-dialog[open],.miau-size-dialog[open]').forEach(dialog=>dialog.close());
    let entry=dialogs.get(url.href);
    if(!entry){entry=create(url,link.textContent.trim());dialogs.set(url.href,entry);}
    document.documentElement.style.overflow='hidden'; entry.dialog.showModal();
    if(!entry.loaded)void load(entry,url);
  });
})();
